import React, { memo } from 'react';
import SVG from './SVG';
export var ArrowNavigation = /*#__PURE__*/memo(function (_ref) {
  var direction = _ref.direction,
      fill = _ref.fill,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '17px' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '25px' : _ref$width;
  return /*#__PURE__*/React.createElement(SVG, {
    fill: fill,
    width: width,
    height: height,
    viewBox: "10 0 5 25",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      transform: "rotate(".concat(direction === 'previous' ? 45 : 225, "deg)")
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,4 L8,16.999 L21,17 L21,21 L4,21 L4,4 L8,4 Z",
    transform: "translate(12.5, 12.5)  translate(-12.5, -12.5)"
  })));
});